import { setDataParams, SetGateWay } from "./gateway";

const { httpGateWay } = SetGateWay();
const httpClient = httpGateWay;

export const getAllSettingApi = (keys) => {
  return httpClient.post(`/option/all`, {
    name: keys,
  });
};

export const addSettingApi = (data) => {
  return httpClient.post(`/option/create`, setDataParams(data));
};

export const getAddressSetting = async () => {
  const keys = [
    "company_name",
    "company_address",
    "company_phone",
    "company_taxid",
  ];
  try {
    const response = await httpClient.post(`/option/all`, {
      name: keys,
    });
    return response.data;
  } catch (e) {
    return null;
  }
};
